import React from 'react';
import { Typography, Button, Row } from 'antd';
import { currencyFormatValue, dateTimeFormat } from 'common';
import { useTranslation } from 'react-i18next';
import { Card } from '../Card';

const { Paragraph, Title, Text } = Typography;

interface PointsBalance {
  balance: {
    balance: number;
  };
  expiryData: {
    amount: number;
    expiredDate: string;
  };
}

interface PointsBalanceCardProp {
  pointsBalance: PointsBalance;
  openAddPointsModal: () => void;
  openResetPointsModal: () => void;
  disabledAdd: boolean;
  disabledEdit: boolean;
}

export const PointsBalanceCard = ({
  pointsBalance,
  openAddPointsModal,
  openResetPointsModal,
  disabledAdd,
  disabledEdit,
}: PointsBalanceCardProp) => {
  const { t } = useTranslation();
  return (
    <Card
      bodyStyle={{
        padding: '16px',
        width: '250px',
        height: '160px',
        backgroundColor: '#F8FAFC',
      }}
    >
      <Paragraph className="text-gray mb-2">{t('label.pointsBalance')}</Paragraph>
      <Title level={4} className="blue-gray-color mt-0">
        {currencyFormatValue(pointsBalance?.balance?.balance ?? 0, 0)}
        {' pts'}
      </Title>
      <Text style={{ color: '#64748B' }}>
        {!pointsBalance?.expiryData?.expiredDate?.includes('9999') ? (
          <>
            {currencyFormatValue(pointsBalance?.expiryData?.amount ?? 0, 0)}{' '}
            {(pointsBalance?.expiryData?.amount || 0) > 1 ? t('label.pointsExpireOn') : t('label.pointExpiresOn')}{' '}
            {dateTimeFormat(pointsBalance?.expiryData?.expiredDate, 'D MMM YYYY')}
          </>
        ) : (
          t('label.noExpiration')
        )}
      </Text>
      <Row className="flex justify-evenly">
        {!disabledAdd && (
          <Button
            className="p-[20px] m-1"
            type="text"
            size="middle"
            style={{ color: '#ffffff', backgroundColor: '#1890FF', width: disabledEdit ? '100%' : '100px' }}
            onClick={openAddPointsModal}
            disabled={disabledAdd}
          >
            {t('label.add')}
          </Button>
        )}
        {!disabledEdit && (
          <Button
            className="p-[20px] m-1"
            type="text"
            size="middle"
            style={{ color: '#ffffff', backgroundColor: '#FF4D4F', width: disabledAdd ? '100%' : '100px' }}
            onClick={openResetPointsModal}
            disabled={disabledEdit}
          >
            {t('label.reset')}
          </Button>
        )}
      </Row>
    </Card>
  );
};
